import { Redirect, Route } from "react-router-dom";
import {
    IonApp,
    IonRouterOutlet,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import Login from "../pages/login/login";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { routes } from "./constants";
import history from "./history";
import React, { useEffect } from "react";
import { PageViewAnalytics } from "../services/analytics/pageViewAnalytics";
import ForgotPassword from "../pages/password/forgotPassword";
import ForgotPasswordComplete from "../pages/password/forgotPasswordComplete";
import Register from "../pages/register/register";
import { MockWatchMessaging } from "../pages/debug/MockWatchMessaging";
import DeveloperTools from "../pages/debug/DeveloperTools";
import PouchDebug from "../pages/debug/PouchDebug";
import PouchDebugMatch from "../pages/debug/PouchDebugMatch";
import AppUrlListener from "../components/AppUrlListener";
import { OneSignalPushListener } from "../components/OneSignalPushListener";
import { RegisterOrLogin } from "../pages/register/registerOrLogin";
import * as rtlDetect from "rtl-detect";

const textDirection = rtlDetect.getLangDir(navigator.language);

interface AuthStackScreenProps {
    targetUrl?: string;
}

function AuthStackScreen({ targetUrl }: AuthStackScreenProps) {
    const userStorageEmail = useSelector(
        (state: RootState) => state.user.usernameOrEmail
    );

    // Store the target URL in sessionStorage for post-login redirect
    useEffect(() => {
        if (targetUrl) {
            console.log("Storing redirect URL:", targetUrl);
            sessionStorage.setItem("redirectAfterLogin", targetUrl);
        }
    }, [targetUrl]);

    return (
        <IonApp className={textDirection}>
            <IonReactRouter history={history}>
                <AppUrlListener></AppUrlListener>
                <OneSignalPushListener />
                <PageViewAnalytics />
                <IonRouterOutlet>
                    <Route
                        path={routes.registerOrLogin}
                        component={RegisterOrLogin}
                    />
                    <Route path={routes.register} component={Register} />
                    <Route path={routes.login} component={Login} />
                    <Route
                        path={routes.forgotPassword}
                        render={() => <ForgotPassword />}
                    />
                    <Route
                        path={routes.resetPassword}
                        component={ForgotPasswordComplete}
                    />
                    <Route
                        path={routes.mockWatchMessaging}
                        component={MockWatchMessaging}
                    />
                    <Route
                        path={routes.developerTools}
                        component={DeveloperTools}
                    />
                    <Route path={routes.pouchDebug} component={PouchDebug} />
                    <Route
                        path={routes.pouchDebugMatch}
                        component={PouchDebugMatch}
                    />
                    <Redirect
                        exact
                        to={
                            userStorageEmail
                                ? routes.login
                                : routes.registerOrLogin
                        }
                        from={"/"}
                    />
                    {targetUrl ? (
                        // Redirect any protected route to login with preserved URL
                        <Redirect to={routes.login} />
                    ) : (
                        <Redirect to={routes.login} from={routes.refsixMore} />
                    )}
                </IonRouterOutlet>
            </IonReactRouter>
        </IonApp>
    );
}

export default AuthStackScreen;
